import { useCallback } from "react";
import { useHistory } from "react-router";
import useAuth from "../auth";

const useErrorHandler = () => {
  const { isAuthenticated, deleteAuth } = useAuth();
  const history = useHistory();

  const handler = useCallback(
    (error) => {
      const {
        message,
        response: {
          status,
          data: { errors },
        },
      } = error;

      let href;

      switch (status) {
        case 401:
          if (isAuthenticated) {
            href = "/";
            deleteAuth();
            alert(errors);
          }

          break;
        default:
          // handle normal errors with some alert or whatever
          // alert('Algo deu errado com sua solicitação. Tente novamente mais tarde ou entre em contato conosco se o problema persistir.')
          if (process.env.NODE_ENV == "development") console.log(error);
      }

      if (href) window.location.href = href;

      return { requestMessage: message, requestErrors: errors };
    },
    [history, deleteAuth]
  );

  return handler;
};

export default useErrorHandler;
